export type ThreatScoreClassification = {
  scanResult: 'Clean' | 'Unscannable' | 'Infected' | 'Analysing';
  category: 'Clean' | 'Undetermined' | 'Threat' | 'Unknown';
  priority: 'Low' | 'Medium' | 'High' | 'Unknown';
  color: string;
  description: string;
  explanation: string;
};

export const classifyThreatScore = (score: number): ThreatScoreClassification => {
  if (score >= 0 && score <= 39) {
    return {scanResult: 'Clean', category: 'Clean', priority: 'Low', color: '#03A9F5', description: 'NO THREAT', explanation: 'No threat detected in scanned email.'};
  }
  if (score >= 40 && score <= 69) {
    return {scanResult: 'Unscannable', category: 'Undetermined', priority: 'Medium', color: '#FFA000', description: 'UNDETERMINED', explanation: 'Unable to analyse all components to determine possible threats.'};
  }
  if (score >= 70 && score <= 100) {
    return {scanResult: 'Infected', category: 'Threat', priority: 'High', color: '#DB071E', description: 'THREAT DETECTED', explanation: 'Threat detected in scanned email.'};
  }
  return {scanResult: 'Analysing', category: 'Unknown', priority: 'Unknown', color: '#909090', description: 'ANALYSING...', explanation: 'This email is in the process of being analysed to determine possible threats.'};
};

/**
 * A matched Header Threat Scoring rule deliberately decouples its score from
 * its severity. Keep the Overview presentation tied to the selected rule
 * category rather than re-classifying the resulting numeric email score.
 */
export const classifyHeaderRuleCategory = (category: unknown): ThreatScoreClassification | undefined => {
  const normalizedCategory = typeof category === 'string' ? category.trim().toLowerCase() : '';

  switch (normalizedCategory) {
    case 'clean':
      return {scanResult: 'Clean', category: 'Clean', priority: 'Low', color: '#03A9F5', description: 'NO THREAT', explanation: 'No threat detected in scanned email.'};
    case 'undetermined':
      return {scanResult: 'Unscannable', category: 'Undetermined', priority: 'Medium', color: '#FFA000', description: 'UNDETERMINED', explanation: 'Unable to analyse all components to determine possible threats.'};
    case 'threat':
      return {scanResult: 'Infected', category: 'Threat', priority: 'High', color: '#DB071E', description: 'THREAT DETECTED', explanation: 'Threat detected in scanned email.'};
    default:
      return undefined;
  }
};
